/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Link } from 'react-router-dom';
import mikeSharedTheme from '../../styles/mikeSharedTheme';

const rootStyle = 
  css`   
    color: ${mikeSharedTheme.palette.text.primary};    
    text-decoration: none;
    font-size: 14px;
    &>span:hover {
      text-decoration: underline;
    },
    &>svg {
      vertical-align: middle;
      margin-right: ${mikeSharedTheme.spacing(1)};
    },
  `;

interface IProps {
  to: string;
  text: string;
  onClickCallBack: () => void;
}

const ProjectLink = (props: IProps) => {
  const { to, text, onClickCallBack } = props;
  const handleClick = (e: any) => {
    e.stopPropagation();
    onClickCallBack();
  };

  return (
    <Link css={rootStyle} to={'/project/' + to} onClick={handleClick}>
      {text}
    </Link>
  );
};

export default ProjectLink;
